import { EMPTY_LIST } from './budgetReducerHelpers';
import { STATUSES } from '../constants/statuses';

export const selectBudgetData = (state) => state.salesBudget?.budgetData || [];
export const selectHistoryData = (state) => state.salesBudget?.historyData || {};
export const selectHistoryDataForType = (rowId) => (state) => {
    const budgetType = state.salesBudget?.budgetType || 'INTERNAL';
    const cacheKey = rowId ? `${rowId}__${budgetType}` : null;
    return cacheKey ? (state.salesBudget?.historyData?.[cacheKey] || {}) : {};
};
export const selectCellHistory = (state) => state.salesBudget?.cellHistory || {};
export const selectActiveTerritory = (state) => state.salesBudget?.activeTerritoryId;
export const selectTerritoryStatus = (id) => (state) => state.salesBudget?.territoryStatuses?.[id] || STATUSES.NEW;
export const selectTerritoryComment = (id) => (state) => state.salesBudget?.territoryComments?.[id] || '';
export const selectVersions = (state) => state.salesBudget?.versions || [];
export const selectBudgetLoading = (state) => state.salesBudget?.loading;
export const selectBudgetInitialized = (state) => state.salesBudget?.isInitialized;
export const selectShowVersionHistory = (state) => state.salesBudget?.showVersionHistory;
export const selectBudgetError = (state) => state.salesBudget?.error;
export const selectYear = (state) => state.salesBudget?.year;
export const selectBudgetType = (state) => state.salesBudget?.budgetType;
export const selectVersionLoading = (state) => state.salesBudget?.versionLoading;
export const selectEurostatData = (state) => state.salesBudget?.eurostatData || {};
export const selectBudgetIsDirty = (state) => state.salesBudget?.isDirty;
export const selectDirtyRowIds = (state) => state.salesBudget?.dirtyRowIds || [];
export const selectHiddenBudgetLines = (state) => state.salesBudget?.hiddenBudgetLines || EMPTY_LIST;
export const selectTerritoryIsDirty = (territoryId) => (state) =>
    territoryId !== null && territoryId !== undefined &&
    (state.salesBudget?.dirtyRowIds || []).some(id => String(id) === String(territoryId));
export const selectInvalidRowIds = (state) => state.salesBudget?.invalidRowIds || [];
export const selectFocusRowRequest = (state) => state.salesBudget?.focusRowRequest || null;
export const selectFilteredRowIds = (state) => state.salesBudget?.filteredRowIds || null;
export const selectCanUndo = (state) => (state.salesBudget?.editHistory || []).length > 0;

export const filterBudgetDataByIds = (budgetData, filteredRowIds) => {
    if (!filteredRowIds) return budgetData || [];
    const idSet = new Set(filteredRowIds);
    return (budgetData || []).filter(row => idSet.has(String(row.id)));
};
export const selectBudgetDocumentIds = (state) => state.salesBudget?.budgetDocumentIds || {};
export const selectIsTooltipEnabled = (state) => state.salesBudget?.isTooltipEnabled || false;
export const selectIsEcoEnabled = (state) => state.salesBudget?.isEcoEnabled || false;
export const selectIsEditMode = (state) => state.salesBudget?.isEditMode || false;
export const selectDisplayedRowCount = (state) => state.salesBudget?.displayedRowCount || 0;
export const selectSelectedRow = (state) => state.salesBudget?.selectedRow;
